export default "__VITE_ASSET__CBtO5W33__"